// extracted by mini-css-extract-plugin
export var dropdownButton = "_42-0";
export var fullWidthDropdownButton = "_42-1";
export var icon = "_42-3";
export var iconPlaceholder = "_42-2";
export var menuItemRow = "_42-8";
export var separator = "_42-d";
export var shortcutContainer = "_42-7";
export var shortcutIconLg = "_42-6";
export var shortcutIconMd = "_42-5";
export var shortcutIconSm = "_42-4";
export var submenuChevron = "_42-c";
export var submenuDropdown = "_42-9";
export var submenuTriggerRow = "_42-a";
export var submenuTriggerRowOpen = "_42-b";